export const ListItemTypes = {
  DOCUMENT: 'document',
};
